const EM_DASH = "—";

function isMissing(v: unknown): boolean {
  return v == null || (typeof v === "number" && Number.isNaN(v));
}

export function pct(v: number | null | undefined): string {
  if (isMissing(v)) return EM_DASH;
  return `${((v as number) * 100).toFixed(1)}%`;
}

export function fmtInt(v: number | null | undefined): string {
  if (isMissing(v)) return EM_DASH;
  return Number(v).toLocaleString();
}

export function fmtNum(v: number | null | undefined, dp = 1): string {
  if (isMissing(v)) return EM_DASH;
  return Number(v).toFixed(dp);
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return EM_DASH;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().slice(0, 10);
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return EM_DASH;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mi = String(d.getUTCMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${mi} UTC`;
}
